import React from 'react'
import PropTypes from 'prop-types'
import { Handle, Position } from '@xyflow/react'

const handleStyle = { width: 8, height: 8 }
const editHandleStyle = { width: 10, height: 10, backgroundColor: '#1976D2' }

export function withStepDefaults (WrappedComponent) {
  function StepNodeWrapper (props) {
    const isEditable = props.data?.editable
    const style = isEditable ? editHandleStyle : handleStyle

    return (
      <div style={{ position: 'relative' }}>
        <Handle
          type='target'
          position={Position.Top}
          style={style}
          isConnectable={isEditable}
        />
        <WrappedComponent {...props} />
        <Handle
          type='source'
          position={Position.Bottom}
          style={style}
          isConnectable={isEditable}
        />
      </div>
    )
  }

  StepNodeWrapper.propTypes = {
    data: PropTypes.shape({
      editable: PropTypes.bool
    })
  }

  StepNodeWrapper.displayName = `withStepDefaults(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`
  return StepNodeWrapper
}
